export default function invalid(c, err) {
  if (!c) {
    throw new Error(err);
  }
}
